var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 2,
    height: 16,
    fill: "#68696B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#68696B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#68696B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#68696B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.98159,
    height: 2,
    rx: 1,
    transform: "matrix(0.634461 0.772955 0.772955 -0.634461 8.75806 6.97418)",
    fill: "#68696B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75806,
    y: 16.8747,
    width: 7.98159,
    height: 2,
    rx: 1,
    transform: "rotate(-50.62 8.75806 16.8747)",
    fill: "#68696B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.09bef081.svg";
export { ForwardRef as ReactComponent };